import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { CartServiceService } from 'src/app/services/cart-service.service';
import { UiServices } from 'src/app/services/ui-services';
import { PasarelaPagoComponent } from 'src/app/pages/vista-compra/components-compra/pasarela-pago/pasarela-pago.component';
import { HttpService } from 'src/app/services/http.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { BalanceService } from 'src/app/services/balance.service';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BranchService } from 'src/app/services/branch.service';
import { DiscountMsgComponent } from './components-compra/discount-msg/discount-msg.component';
// import { ChangeBranchComponent } from 'src/app/components/change-branch/change-branch.component';

@Component({
  selector: 'app-vista-compra',
  templateUrl: './vista-compra.page.html',
  styleUrls: ['./vista-compra.page.scss'],
})
export class VistaCompraPage implements OnInit, OnDestroy {
  public canasta: any[] = [];
  private _domainId = environment.domainId;
  public products: any[] = [];
  public loaded = false;
  public openWp = false;
  public currency: any;
  public currencyName = 'USD';
  private balanceObs: Subscription = new Subscription();
  public pendingOrders = [];
  public selectedBranchId = undefined;

  constructor(
    public cartService: CartServiceService,
    public paramSv: ParamServicesService,
    public loginSv: LoginService,

    private storageService: StorageService,
    private balanceSv: BalanceService,
    private uiSv: UiServices,
    private httpSv: HttpService,
    private navCtrl: NavController,
    private trSv: TranslateService,
    private cdr: ChangeDetectorRef,
    public branchSv: BranchService
  ) {
    this.balanceObs.add(
      this.paramSv.reload.subscribe(() => {
        this.getRelatedProducts();
      })
    );
  }

  async ngOnInit(): Promise<void> {
    try {
      this.navCtrl.navigateRoot('/cart');
      if (!this.branchSv.branches.length) await this.branchSv.getBranchs();
      const resOrders = await this.httpSv.itemIndex('client/order', '');
      this.pendingOrders = resOrders?.data;
      if (this.balanceSv.currency) {
        this.setCurrency(this.balanceSv.currency);
      }
      this.balanceObs = this.balanceSv.currencySource.subscribe((currency) => {
        this.setCurrency(currency);
      });
      this.getRelatedProducts();
      // this.updatedCart();
    } catch (err) {
      console.error(err);
    }
  }

  setCurrency(currency) {
    this.currency = currency;
    this.currencyName =
      this.currency?.symbol || this.balanceSv.currencyBaseName;
  }

  async getRelatedProducts() {
    const body = {
      domainId: this._domainId,
      catalogue: '',
      pag: '1',
      search: '',
      category: '',
      from: '',
      orden: '',
      promo: '1',
      upTo: '',
    };
    const res: any = await this.httpSv.searchProduct(body);
    const products = res.data.product.data;
    this.products = products;
  }

  ngOnDestroy(): void {
    this.balanceObs.unsubscribe();
  }

  ionViewWillEnter(): void {
    if (!this.canasta.length) {
      this.updatedCart();
    }
  }

  updatedCart(): void {
    // this.cartService.total = 0;
    setTimeout(async () => {
      this.loaded = false;
      const savedCart: any[] = await this.cartService.compareCart(false);
      await this.cartService.saveOptions(savedCart);
      this.loaded = true;
      this.canasta = savedCart || [];
    }, 1000);
  }

  trackByItems(index, item): any {
    return item.id;
  }

  ionViewWillLeave(): void {
    this.canasta = [];
  }

  async reset(producto): Promise<void> {
    this.canasta = this.canasta.filter(
      (item) => item.idProduct !== producto.idProduct
    );
    producto.checked = !producto.checked;
    this.cartService.cart = this.canasta;
    if (!this.canasta.length) {
      this.cartService.cart = [];
      await this.storageService.remove('cart');
      this.cartService.setLength();
      return;
    } else {
      await this.storageService.set('cart', this.canasta);
      this.cartService.setLength();
    }
  }

  findProduct(storage, userId, type): Promise<unknown> {
    if (!storage) return null;
    return new Promise((resolve, reject) => {
      resolve(
        storage.find((user) => {
          if (!user[type]) {
            return null;
          }
          return user[type].id === userId;
        })
      );
    });
  }

  async comprar() {
    let minClient = this.paramSv.dispatch?.minClient;
    let minDist = this.paramSv.dispatch?.minDist;
    let min: any = 0;
    if (
      !(
        this.paramSv.dispatch.value === 'wpp' &&
        this.paramSv.dispatch?.buyLogin &&
        !this.loginSv.user
      )
    ) {
      if (
        (!this.paramSv.dispatch?.buyLogin && !this.loginSv.user) ||
        ((this.paramSv.dispatch.value === 'wpp' ||
          this.paramSv.dispatch.value === 'both') &&
          !this.loginSv.user)
      ) {
        const tr = this.trSv.instant(
          'DEBES_REGISTRARTE_ANTES_DE_CONTINUAR_CON_TU_COMPRA'
        );
        const { role } = await this.uiSv.presentAlert(tr, true);
        if (role === 'accept') {
          const queryParams = { redirectTo: 'cart' };
          await this.navCtrl.navigateForward('auth', { queryParams });
        }
        return true;
      }
    }
    if (minClient !== 0 && this.loginSv.user?.rolId !== 7) {
      min = minClient;
    } else if (
      minDist !== 0 &&
      this.loginSv.user?.rolId === 7 &&
      this.paramSv.existDistributorSignUp
    ) {
      min = minDist;
    }
    min = Number(min);

    if (
      this.currency &&
      min !== 0 &&
      min > Number(this.cartService.totalQuantity)
    ) {
      if (this.currency.type === 1) {
        min = (min * this.currency?.change).toFixed(2);
      } else {
        min = (min / this.currency?.change).toFixed(2);
      }
      const tr = this.trSv.instant(
        'EL_MONTO_MINIMO_DE_COMPRA_DEBE_SER_MAYOR_A'
      );
      return await this.uiSv.presentAlert(`${tr}: ${min}${this.currencyName}`);
    }

    const list = this.canasta.filter(
      (producto) =>
        producto.isChecked && producto.isActive && producto.isInBranch
    );
    if (!list.length) {
      const tr = this.trSv.instant(
        'DEBES_SELECCIONAR_AL_MENOS_UN_PRODUCTO_PARA_CONTINUAR_CON_LA_COMPRA'
      );
      await this.uiSv.showToast(tr);
      return;
    }
    await this.next(list);
  }

  deleteProduct(item) {
    const indexOf = this.canasta.findIndex((product) => {
      if (product.id === item.id) {
        if (
          this.paramSv.dispatch?.branch &&
          product.branchContactId === this.cartService.selectedBranchId
        ) {
          return true;
        } else if (!this.paramSv.dispatch?.branch) {
          return true;
        }
      }
    });

    this.canasta.splice(indexOf, 1);
    this.canasta = [...this.canasta];
    if (!this.loginSv.user) this.cartService.setLength(false);
    this.cdr.detectChanges();
  }

  contactar() {
    let cart: string = this.cartService.buildCartMessage(this.canasta);
    return cart;
  }

  async next(list) {
    try {
      const dispatchType = this.paramSv.dispatch.value;
      if (!this.canasta.length) {
        const tr = this.trSv.instant('NO_TIENES_NINGUN_PRODUCTO_EN_EL_CARRITO');
        await this.uiSv.showToast(tr);
        return;
      } else if (
        this.paramSv.dispatch?.branch &&
        !this.loginSv.branchContactId
      ) {
        const defaultTxt =
          this.paramSv.dispatch.branchMsg ||
          this.trSv.instant(
            'DEBES_SELECCIONAR_UNA_SUCURSAL_ANTES_DE_CONTINUAR'
          );

        return await this.uiSv.presentAlert(defaultTxt, false);
        // return await this.uiSv.showPopover(
        //   ChangeBranchComponent,
        //   {},
        //   'branch-pop'
        // );
      }
      if (!this.loginSv.user && !this.paramSv.dispatch?.buyLogin) {
        const cart = this.contactar();
        window.open(
          `https://wa.me/${this.paramSv.numWpp}?text=${cart}`,
          '_blank'
        );
        return;
      }

      if (dispatchType === 'onlyWpp') {
        let cart = `Cliente: ${this.loginSv.user?.name || ''}%0A%0A`;
        cart += this.contactar();
        window.open(
          `https://wa.me/${this.paramSv.numWpp}?text=${cart}`,
          '_blank'
        );
        if (this.loginSv.user) {
          await this.cartService.deleteCart(this.canasta[0].cartId);
        } else {
          await this.storageService.remove('cart');
        }
        this.updatedCart();
        return true;
      }

      const verifyExistMeet = await this.cartService.verifyExistMeet();
      if (!verifyExistMeet) {
        this.navCtrl.navigateBack('marketplace', {
          queryParams: this.cartService.marketplaceFilers,
        });
        return false;
      }
      const { data } = await this.uiSv.showModal(
        PasarelaPagoComponent,
        {
          total: this.cartService.totalQuantity,
          list,
          paramDispatch: this.paramSv.dispatch,
        },
        'pasarela-pago',
        false
      );
      if (data?.text === 'sended') {
        const tr = this.trSv.instant(
          'HOLA_SU_PAGO_HA_SIDO_ENVIADO_EXITOSAMENTE_PRONTO_RECIBIRA_UN_CORREO_DE_CONFIRMACION_BIENVENIDO'
        );
        const trAlert = this.trSv.instant('GRACIAS');
        await this.uiSv.presentAlert(
          tr,
          false,
          'ACEPTAR',
          true,
          'CANCELAR',
          trAlert
        );
        const openWp = this.paramSv?.dispatch?.value;
        this.updatedCart();
        if (openWp === 'wpp' || openWp === 'both') {
          window.open(
            `https://wa.me/${this.paramSv.numWpp}?text=${data.cart}`,
            '_blank'
          );
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  async seeOrders() {
    await this.navCtrl.navigateRoot('pending-orders');
  }

  ionSegment(ev) {
    this.selectedBranchId = Number(ev.detail.value);
    if (!this.loginSv.branchContactId) {
      this.loginSv.branchContactId = this.selectedBranchId;
    }
    this.cartService.selectedBranchId = this.selectedBranchId;
    this.navCtrl.navigateRoot('/cart', {
      queryParams: { branchId: this.selectedBranchId },
    });
    this.cartService.setLength(false);
  }

  showDiscountMsg(ev) {
    this.uiSv.showPopover(
      DiscountMsgComponent,
      { discountName: this.loginSv.user.customerDiscount.name },
      '',
      ev,
      'bottom',
      'ios'
    );
  }
}
